import React from 'react';
import { Card, CardContent, Typography, Box } from '@mui/material';
import { PolarArea } from 'react-chartjs-2';
import { Chart, registerables } from 'chart.js';
Chart.register(...registerables);

const UserAnalytics = ({ users }) => {
  // Calculate user counts by role
  const adminCount = users.filter(user => user.role === 'admin').length;
  const facultyCount = users.filter(user => user.role === 'faculty').length;
  const studentCount = users.filter(user => user.role === 'student').length;

  return (
    <Box sx={{ mb: 4, width: '100%' }}>
      {/* Heading */}
      <Typography
        variant="h6"
        gutterBottom
        sx={{
          textAlign: 'center',
          fontWeight: 'bold',
          color: '#1976d2',
          mb: 1, 
        }}
      >
        User Distribution by Role
      </Typography>

      {/* Card */}
      <Card
        sx={{
          borderRadius: '16px',my:"6vh",
          boxShadow: '0 4px 8px rgba(0, 0, 0, 0.1)',
          transition: 'transform 0.3s',
          height: '290px', 
          width:"40vw",
          '&:hover': {
            transform: 'scale(1.02)',
            boxShadow: '0 8px 16px rgba(0, 0, 0, 0.15)',
          },
        }}
      >
        <CardContent
          sx={{
            padding: 2,
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            height: '100%',
          }}
        >
          {/* Polar Chart */}
          <PolarArea
            data={{
              labels: ['Admin', 'Faculty', 'Students'],
              datasets: [
                {
                  label: 'Total Users',
                  data: [adminCount, facultyCount, studentCount],
                  backgroundColor: [
                    'rgba(25, 118, 210, 0.6)', 
                    'rgba(76, 175, 80, 0.6)',  
                    'rgba(255, 193, 7, 0.6)', 
                  ],
                  borderColor: [
                    'rgba(25, 118, 210, 1)', 
                    'rgba(76, 175, 80, 1)', 
                    'rgba(255, 193, 7, 1)',
                  ],
                  borderWidth: 1.5,
                },
              ],
            }}
            options={{
              responsive: true,
              maintainAspectRatio: false, 
              plugins: {
                legend: {
                  position: 'top',
                  labels: {
                    color: '#333',
                    font: {
                      size: 12,
                    },
                  },
                },
              },
              layout: {
                padding: {
                  top: 10,
                },
              },
            }}
            style={{
              height: '200px', 
              width: '100%',
            }}
          />
        </CardContent>
      </Card>
    </Box>
  );
};

export default UserAnalytics;
